import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'

import { ROUTE_PATHS } from 'router/routes'

import { ResetPasswordConfirmPage, VerifyEmailPage } from 'modules/Emails/pages'

import { RedirectToDeposit } from './redirects'

export class EmailsModule {
  getRoutes() {
    return (
      <Route key={ROUTE_PATHS.EMAIL} path={ROUTE_PATHS.EMAIL}>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Switch>
            <Route
              key={ROUTE_PATHS.EMAIL_VERIFY_EMAIL}
              path={ROUTE_PATHS.EMAIL_VERIFY_EMAIL}
              component={VerifyEmailPage}
            />
            <Route
              key={ROUTE_PATHS.EMAIL_VERIFY_PASSWORD_CONFIRM}
              path={ROUTE_PATHS.EMAIL_VERIFY_PASSWORD_CONFIRM}
              component={ResetPasswordConfirmPage}
            />
            <Route
              key={ROUTE_PATHS.EMAIL_REDIRECT_DEPOSIT}
              path={ROUTE_PATHS.EMAIL_REDIRECT_DEPOSIT}
              component={RedirectToDeposit}
            />
          </Switch>
        </QueryParamProvider>
      </Route>
    )
  }
}
